const list = [
  {
    id: '5',
    parentId: '-1',
    name: '数据看板',
    label: '数据看板',
    path: '/data_board',
    icon: "el-icon-s-grid",
  },
  {
    id: '4',
    parentId: '-1',
    name: '财粮配置',
    label: '财粮配置',
    path: '/banner',
    icon: "el-icon-menu",
  },
  {
    id: '0',
    parentId: '-1',
    name: '组织申请审批',
    label: '组织申请审批',
    path: '/examine_Manage',
    icon: "el-icon-coordinate",
    children: [{
      id: '01',
      parentId: '0',
      name: '公司认证审批',
      label: '公司认证审批',
      path: '/company_approval',
      icon: "",
    },{
      id: '02',
      parentId: '0',
      name: '组织申请审批',
      label: '组织申请审批',
      path: '/org_approval',
      icon: "",
    },]
  },
  {
    id: '3',
    parentId: '-1',
    name: '审计管理',
    label: '审计管理',
    path: '/',
    icon: "el-icon-document-copy",
    children: [{
      id: '01',
      parentId: '0',
      name: '日志管理',
      label: '日志管理',
      path: '/record',
      icon: "",
    }]
  },
  {
    id: '1',
    parentId: '-1',
    name: '文档中心',
    label: '文档中心',
    path: '/file_Manage',
    icon: "el-icon-folder-opened",
    children: [
      {
        id: '11',
        parentId: '1',
        name: '文档管理',
        label: '文档管理',
        path: '/file_Manage',
        icon: "",
      },
      {
        id: '12',
        parentId: '1',
        name: '系统内容配置',
        label: '系统内容配置',
        path: '/page_File',
        icon: "",
      }]
  },
  {
    id: '2',
    parentId: '-1',
    name: '运营管理',
    label: '运营管理',
    path: '/operate_manage',
    icon: "el-icon-set-up",
    children: [
      {
        id: '21',
        parentId: '2',
        name: '系统用户管理',
        label: '系统用户管理',
        path: '/user',
        icon: "",
      },
      {
        id: '22',
        parentId: '2',
        name: '系统公司管理',
        label: '系统公司管理',
        path: '/company',
        icon: "",
      }
    ]
  },
]

export {
  list
}



// WEBPACK FOOTER //
// ./src/pages/main/layout/config.js